import { useCSVEnrichmentRequest } from "../../apis/csv-enrichment/useCSVEnrichmentRequest";

export const useCSVEnrichmentHandlers= () => {
    const { calculateCSVEnrichment, parseCsv, getEnrichedTransactionByClientSecret, getEnrichedCSVs, getCreditOptions } = useCSVEnrichmentRequest()

    const calculateCsvEnrichmentHandler = async (payload: any) => {
        const result = await calculateCSVEnrichment(payload);
        return result;
    }

    const parseCsvHandler = async (payload: any) => {
        const result = await parseCsv(payload);
        return result;
    }

    const getEnrichedTransactionByClientSecretHandler = async (payload: any) => {
        const result = await getEnrichedTransactionByClientSecret(payload);
        return result;
    }

    const getEnrichedCSVsHandler = async (payload: any) => {
        const result = await getEnrichedCSVs(payload);
        return {
            data: result?.data ?? [],
            meta: {
                pages: result?.meta?.last_page ?? 1,
                totalCount: result?.meta?.total ?? 0
            }
        }
    }

    const getCreditOptionsHandler = async () => {
        const result = await getCreditOptions();
        return result;
    }

    return {
        parseCsvHandler,
        calculateCsvEnrichmentHandler,
        getEnrichedTransactionByClientSecretHandler,
        getEnrichedCSVsHandler,
        getCreditOptionsHandler,
    };
}

